'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDressCheck = exports.dressCheckForPersonAndAdjUrl = exports.dressCheckForPersonUrl = exports.dressChecksUrl = exports.dressChecksReportUrl = exports.dressCheckPrefixUrl = undefined;

var _immutable = require('immutable');

var dressCheckPrefixUrl = exports.dressCheckPrefixUrl = function dressCheckPrefixUrl(fid, eid, aid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/events/' + eid + '/adjudicators/' + aid;
};

var dressChecksReportUrl = exports.dressChecksReportUrl = function dressChecksReportUrl(fid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/dress-checks/report';
};

var dressChecksUrl = exports.dressChecksUrl = function dressChecksUrl(fid, eid, aid) {
  return dressCheckPrefixUrl(fid, eid, aid) + '/dress-checks';
};

var dressCheckForPersonUrl = exports.dressCheckForPersonUrl = function dressCheckForPersonUrl(fid, eid, pid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/events/' + eid + '/persons/' + pid + '/dress-check';
};

var dressCheckForPersonAndAdjUrl = exports.dressCheckForPersonAndAdjUrl = function dressCheckForPersonAndAdjUrl(fid, eid, aid, pid) {
  return dressCheckPrefixUrl(fid, eid, aid) + '/persons/' + pid + '/dress-check';
};

var getDressCheck = exports.getDressCheck = function getDressCheck(state, dressCheckId) {
  return dressCheckId && state.getIn(['dresschecks', 'one', dressCheckId]) || (0, _immutable.Map)() || (0, _immutable.Map)();
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/dress-checks/paths.js
// module id = 39
// module chunks = 0